import PropTypes from "prop-types";
import { connect } from "react-redux";
import React from "react";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import PageLayout from "../PageLayout";
import { getErrorMessage } from "./ErrorMessage";
import { fetchFormData } from "../../actions/formData";
import "./ErrorPage.css";

const logoPath =
  window.location.hostname.indexOf("bharatpepg") >= 0
    ? "/images/error-logos/bharatpepg_logo.png"
    : "/images/error-logos/lyra_logo.png";

const ErrorPage = ({ match, dispatch, formData, error }) => {
  if (!formData && !error) {
    dispatch(fetchFormData(match.params.id));
  }

  if (error) return `Could Not Fetch Information for : ${match.params.id}`;
  if (!formData) return "";
  return (
    <PageLayout>
      <div className="error-title-wrapper">
        <div>
          <Typography className="errorMessage" variant="h5">
            {getErrorMessage(match.params.code)}
          </Typography>
        </div>
        <div>
          <img className="lyra-logo" src={logoPath} alt="Lyra logo" />
        </div>
      </div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Field</TableCell>
            <TableCell>Received value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(formData)
            .sort()
            .map(fieldName => (
              <TableRow key={fieldName}>
                <TableCell>{fieldName}</TableCell>
                <TableCell>{formData[fieldName]}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </PageLayout>
  );
};

ErrorPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired
    })
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  formData: PropTypes.string.isRequired,
  error: PropTypes.string.isRequired
};

function mapStateToProps({ formDataReducer }) {
  return formDataReducer;
}

export default connect(mapStateToProps)(ErrorPage);
